export const isMobileScreen = (): boolean => window.innerWidth < 770
export const capitalize = (cad: string): string =>
  cad.replace(/(^\w{1})|(\s+\w{1})/g, (letter: string) => letter.toUpperCase())
